import {
  Button,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ServiceTokenListItem } from '@/entities/serviceTokens';

type Props = {
  token: ServiceTokenListItem;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
};

export const RevokeTokenDialog: FC<Props> = ({ token, onConfirm, onCancel, isLoading }) => {
  const { t } = useTranslation(['users', 'common']);

  return (
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle>{t('users:revokeToken')}</DialogTitle>
      </DialogHeader>

      <DialogDescription className="flex flex-col gap-2">
        <span>{t('users:revokeTokenDescription', { description: token.description })}</span>
        <span className="font-mono text-sm text-muted-foreground">
          {t('users:tokenPrefix', { prefix: token.tokenPrefix })}
        </span>
        <span className="text-destructive text-sm">{t('users:revokeTokenWarning')}</span>
      </DialogDescription>

      <DialogFooter>
        <DialogClose asChild>
          <Button variant="ghost" onClick={onCancel}>
            {t('common:cancel')}
          </Button>
        </DialogClose>
        <Button color="destructive" variant="outline" onClick={onConfirm} isLoading={isLoading}>
          {t('users:revoke')}
        </Button>
      </DialogFooter>
    </DialogContent>
  );
};
